module.exports = __webpack_public_path__ + "static/media/09tonghaojianxiugong2.88b2079f.png";